var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4 0H9.6C4.29807 0 0 4.29807 0 9.6V54.4C0 59.7019 4.29807 64 9.6 64H54.4C59.7019 64 64 59.7019 64 54.4V9.6C64 4.29807 59.7019 0 54.4 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 7.88672H12.5469V8.38672V15.1934V15.6934H13.0469H38.1209L11.6736 53.689L11.584 53.8177V53.9746V56V56.5H12.084H50.4336H50.9336V56V49.1934V48.6934H50.4336H24.3972L50.8439 10.7311L50.9336 10.6023V10.4453V8.38672V7.88672H50.4336H13.0469Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownIcon);
export default __webpack_public_path__ + "static/media/unknown_icon.2f9365a147cf8efaeb065cefa693ae4c.svg";
export { ForwardRef as ReactComponent };